export default "__VITE_ASSET__CUVVarBI__"